import { getOptionValue } from "@helpers/options";
import axios from "@common/api/desktop/axios";
import { mapToSelect } from "./egm";

class Ownership {
  getProfiles = async (operator) => {
    const response = await axios.get(
      `OwnershipProfile/Profiles?operatorId=${operator}`,
    );
    return response.data;
  };

  getProfile = async (profileId) => {
    const response = await axios.get(
      `OwnershipProfile/Profile?profileId=${profileId}`,
    );
    return response.data;
  };

  getProfileAttributes = async (profileId) => {
    const response = await axios.get(
      `OwnershipProfile/profile/attributes?profileId=${profileId}`,
    );
    return response.data;
  };

  getTypes = async (operator) => {
    const response = await axios.get(
      `OwnershipProfile/OwnershipTypes?operatorId=${operator}`,
    );
    return mapToSelect(response.data);
  };

  getTypeAttributes = async (typeId) => {
    const response = await axios.get(
      `OwnershipProfile/OwnershipType/attributes?ownershipTypeId=${typeId}`,
    );
    return response.data;
  };

  saveProfile = async (operatorId, name, ownershipTypeId, values, id) => {
    const response = await axios.post(`OwnershipProfile/Profile/update`, {
      id,
      operatorId,
      name,
      ownershipTypeId,
      values: values.map((x) => {
        return { attributeTypeId: parseInt(x.code), value: getOptionValue(x) };
      }),
    });

    return response.data;
  };

  createProfile = async (operatorId, name, ownershipTypeId, values) => {
    const response = await axios.post(`OwnershipProfile/Profile/create`, {
      operatorId,
      name,
      ownershipTypeId,
      values: values.map((x) => {
        return { attributeTypeId: parseInt(x.code), value: getOptionValue(x) };
      }),
    });

    return response.data;
  };
}

const ownership = new Ownership();

export default ownership;
